import { render, staticRenderFns } from "./AllProject.vue?vue&type=template&id=8b2c462a&scoped=true"
import script from "./AllProject.vue?vue&type=script&lang=js"
export * from "./AllProject.vue?vue&type=script&lang=js"
import style0 from "./AllProject.vue?vue&type=style&index=0&id=8b2c462a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2c462a",
  null
  
)

export default component.exports